import { useEffect, useReducer } from 'react';
import axios from 'axios';
import { dataFetchReducer } from './utils/dataFetchReducer';
import { systemCode, xs_languageCode } from '..';
import { getConfiguration } from './utils/configuration';
import { getTimezoneOffset } from './utils/getTimezoneOffset';
import { parseTournamentsByDate } from './parseTournamentsByDate';

let source = null;

export function useFetchTournamentsByDate(date, sportId, aggregata, hoursLimit) {
    const [state, dispatch] = useReducer(dataFetchReducer, {
        isLoading: true,
        isError: false,
        newData: null
    });
    
    useEffect(() => {
        let didCancel = false;

        const fetchData = async (url, params, callback) => {
            if (source != null) {
                source.cancel();
            }
            source = axios.CancelToken.source();
            dispatch({ type: 'FETCH_INIT' });
            try {
                const result = await axios.get(url, {cancelToken: source.token, params});
                if (!didCancel) {
                    callback(result.data);
                }
            } catch (error) {
                console.error('Errore ' + url + ': ' + error);
                if (!didCancel) {
                    dispatch({ type: 'FETCH_FAILURE' });
                }
            }
        };

        const url = getConfiguration().api.getPalinsestoDelGiorno;
        const params = {
            systemCode,
            lingua: xs_languageCode,
            hash: '',
            data: date,
            idSport: sportId,
            idAggregata: aggregata,
            timezone: getTimezoneOffset()
        };
        fetchData(url, params, function(response) {
            const data = parseTournamentsByDate(response, date, sportId, aggregata, hoursLimit);
            dispatch({ type: 'FETCH_SUCCESS', payload: data });
        });

        return () => {
            didCancel = true;
        };
    }, [date, sportId, aggregata, hoursLimit]);

    return [state, dispatch];
}
